import {BankAccount} from '../model/bank-account';
import {BankAccountInteractor} from '../interactors/bank-account.interactor';
import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {UserInteractor} from '../interactors/user.interactor';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {LenderDetailsService} from '../service/lender-details.service';
import {isEmpty} from 'lodash';

@Injectable()
export class BankAccountResolver implements Resolve<BankAccount> {
    constructor(private bankAccountInteractor: BankAccountInteractor, private userInteractor: UserInteractor, private loanApplicationInteractor: LoanApplicationInteractor, private lenderDetailsService: LenderDetailsService) {
    }

    async resolve(): Promise<BankAccount> {
        const loanApplication = await this.loanApplicationInteractor.get();
        if (loanApplication.bankAccountId) {
            return await this.bankAccountInteractor.get(loanApplication.bankAccountId);
        }
        try {
            const lenderDetails = await this.lenderDetailsService.getLenderInfo(await this.userInteractor.getUserId());
            if (isEmpty(lenderDetails.bank_account)) {
                return undefined;
            }

            const lenderBankAccount = lenderDetails.bank_account;
            lenderBankAccount._id = undefined;
            return lenderBankAccount;
        } catch {
            return undefined;
        }
    }
}
